/**
 * Lo que ve un dueño cuya identidad todavía no está (GKTIBO-120, revisión del
 * 2026-09-24): sin nombre de negocio no hay bot que enseñar ni cierre que
 * mostrar. Antes ese caso caía en «Tu bot está listo».
 */
export const identidad = {
  titulo: 'Falta terminar de crear tu negocio',
  ayuda: 'Necesitamos el nombre de tu negocio para seguir.',
};
